import { render, staticRenderFns } from "./WhatIfILoseMyKeysOrPassword.vue?vue&type=template&id=072fcf8a&scoped=true&"
import script from "./WhatIfILoseMyKeysOrPassword.vue?vue&type=script&lang=js&"
export * from "./WhatIfILoseMyKeysOrPassword.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfILoseMyKeysOrPassword.vue?vue&type=style&index=0&id=072fcf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fcf8a",
  null
  
)

export default component.exports